var React = require('react');

function CrossInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M27 27L19.9611 19.9611L13 13","strokeWidth":"2","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M27 13L20 20L13 27","strokeWidth":"2","strokeLinecap":"round","key":1})]);
}

CrossInline.defaultProps = {"viewBox":"0 0 40 40","fill":"none"};

module.exports = CrossInline;

CrossInline.default = CrossInline;
